import axios from "axios";
import { ResetPasswordError } from "../auth/constants";

export const fetchPasswordResetEligibility = async (email: string): Promise<ResetPasswordError> => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_SPL_URL}/v1/user/password-reset/check`,
      { email },
      { withCredentials: true },
    );

    return data;
  }
  catch (error) {
    console.error("Error fetching eligibility to reset password:", error);
    throw error;
  }
};

export const trackPasswordResetAttempt = async (email: string) => {
  try {
    await axios.post(
      `${process.env.REACT_APP_SPL_URL}/v1/user/password-reset/mark`,
      { email },
      { withCredentials: true },
    );
  }
  catch (error) {
    console.error("Error tracking password reset attempt:", error);
    throw error;
  }
};
